jQuery(document).ready(function() {
    if (!jQuery('#map').length) {
    return;
  }
  function new_map(el) {
    var markers = jQuery(el.find('.marker'));
    var args = {
      zoom: 16,
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    var map = new google.maps.Map(el[0], args);
    map.markers = [];
    markers.each(function () {
      add_marker(jQuery(this), map);
    });
    center_map(map);
    return map;
  }
  function add_marker(marker, map) {
    var address = marker.attr('data-address');
    var lat = marker.attr('data-lat');
    var lng = marker.attr('data-lng');
    var latlng = new google.maps.LatLng(marker.attr('data-lat'), marker.attr('data-lng'));
    var icon = {
      url: marker.attr('data-icon'),
    };
    var markerArgs = {
      position: latlng,
      map: map,
      optimized: false,
      icon: icon,
    };
    var marker = new google.maps.Marker(markerArgs);
    map.markers.push(marker);
  }
  function center_map(map) {
    var bounds = new google.maps.LatLngBounds();
    var zoom = parseInt(16);
    jQuery.each(map.markers, function (i, marker) {
      var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      bounds.extend(latlng);
    });
    if (map.markers.length !== 1) {
      map.fitBounds(bounds);
    }
  }
  jQuery('#map').each(function () {
    new_map(jQuery(this));
  });
});